import PageTitle from "@component/PageTitle";
import { DeductionType } from "@constant/ThroughShipment";
import { dealerState, fetchBatchUpdateDeductionFee, fetchDeductionFeeList } from "@redux/dealerSlice";

import React, { useEffect, useState } from "react";
import { Button, Card, Col, InputNumber, message, Radio, RadioChangeEvent, Row } from "antd";
import Paragraph from "antd/lib/typography/Paragraph";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

const Wrapper = styled.div`
  padding: 20px 20px 20px 25px;

  .ant-table-tbody {
    .ant-table-placeholder > td {
      border: 0;
    }
  }
`;
const Footer = styled.div`
  position: fixed;
  right: 25px;
  bottom: 0;
  width: 100%;
  display: flex;
  padding: 13px 12px;
  align-items: center;
  justify-content: flex-end;
  background-color: #fafafa;
  box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.05);
`;
export default function DeductionFee() {
  const dispatch = useDispatch();
  const {
    deductionFeeList: { results: deductionList },
    deductionFilter,
    dealerInfo,
  } = useSelector(dealerState);

  const [postDeduction, setPostDeduction] = useState({ rate: 0, isActive: true });
  const [preDeduction, setPreDeduction] = useState({ rate: 0, isActive: true });

  const radioPostOnChange = (e: RadioChangeEvent) => {
    const { value } = e.target;
    setPostDeduction({ ...postDeduction, isActive: value });
  };

  const radioPreOnChange = (e: RadioChangeEvent) => {
    const { value } = e.target;
    setPreDeduction({ ...preDeduction, isActive: value });
  };

  const onSubmit = () => {
    if (deductionList.length === 0 || !dealerInfo) {
      message.error("無法更新費用，請洽工程");
      return;
    }
    dispatch(
      fetchBatchUpdateDeductionFee({
        deductions: [
          {
            rate: postDeduction.rate,
            deductionType: DeductionType.POST_DEDUCTION,
            isActive: postDeduction.isActive,
          },
          {
            rate: preDeduction.rate,
            deductionType: DeductionType.PRE_DEDUCTION,
            isActive: preDeduction.isActive,
          },
        ],
        retailerId: dealerInfo.retailer.id,
      }),
    );
  };

  useEffect(() => {
    if (dealerInfo) dispatch(fetchDeductionFeeList({ retailer: dealerInfo.retailer.id, ...deductionFilter }));
  }, [dispatch, deductionFilter, dealerInfo]);

  useEffect(() => {
    if (deductionList.length === 0) return;
    const state = deductionList.reduce<{
      post: { rate: number; isActive: boolean } | null;
      pre: { rate: number; isActive: boolean } | null;
    }>(
      (acc, item) => {
        if (item.deductionType === DeductionType.POST_DEDUCTION) {
          acc.post = { rate: item.rate, isActive: item.isActive };
        } else if (item.deductionType === DeductionType.PRE_DEDUCTION) {
          acc.pre = { rate: item.rate, isActive: item.isActive };
        }
        return acc;
      },
      { post: null, pre: null },
    );

    if (state.post) setPostDeduction(state.post);
    if (state.pre) setPreDeduction(state.pre);
  }, [deductionList]);

  return (
    <Wrapper>
      <PageTitle title="通路/經銷商 - 後扣費用" />
      <Card>
        <Paragraph>後扣設定</Paragraph>
        <Radio.Group onChange={radioPostOnChange} value={postDeduction.isActive}>
          <Row align="middle" style={{ marginBottom: "12px" }}>
            <Col>
              <Radio value>後扣根據通路設定</Radio>
            </Col>
            <Col span={12}>
              <InputNumber
                addonBefore="後扣"
                addonAfter="%"
                value={postDeduction.rate}
                onChange={(value) => setPostDeduction({ ...postDeduction, rate: value || 0 })}
                min={0}
                max={100}
                step={0.01}
                precision={3}
              />
            </Col>
          </Row>
          <Row>
            <Radio value={false}>後扣根據通路商品設定</Radio>
          </Row>
        </Radio.Group>
      </Card>
      <Card style={{ marginTop: "20px" }}>
        <Paragraph>前抽設定</Paragraph>
        <Radio.Group onChange={radioPreOnChange} value={preDeduction.isActive}>
          <Row align="middle" style={{ marginBottom: "12px" }}>
            <Col>
              <Radio value>前抽根據通路設定</Radio>
            </Col>
            <Col span={12}>
              <InputNumber
                addonBefore="前抽"
                addonAfter="%"
                value={preDeduction.rate}
                onChange={(value) => setPreDeduction({ ...preDeduction, rate: value || 0 })}
                min={0}
                max={100}
                step={0.01}
                precision={3}
              />
            </Col>
          </Row>
          <Row>
            <Radio value={false}>前抽根據通路商品設定</Radio>
          </Row>
        </Radio.Group>
      </Card>
      <Footer>
        <Button type="primary" onClick={onSubmit}>
          儲存此分頁
        </Button>
      </Footer>
    </Wrapper>
  );
}
